import Keycahin1 from '../../images/PortfolioImg/promotional/leather keychine/l5.jpg'
import Keycahin2 from '../../images/PortfolioImg/promotional/wood keychine/w6.jpg'
import Keycahin3 from '../../images/PortfolioImg/promotional/metal keychines/m2.jpg'
import Keycahin4 from '../../images/PortfolioImg/promotional/pvc keychine/p5.jpg'

const KeychainServiceCards = [
  {
    id: 1,
    name: "Leather Keychain",
    description: "Premium leather keychains that combine durability with a sophisticated look-ideal for corporate gifting and high-end branding.",
    key:"keychain1",
    image: Keycahin1
  },
  {
    id: 2,
    name: "Wood Keychain",
    description: "Eco-friendly wooden keychains with a smooth, natural finish-perfect for brands that prioritize sustainability and simplicity.",
    key: "keychain2",
    image: Keycahin2
  },
  {
    id: 3,
    name: "Metal Keychain",
    description: "Sleek and durable metal keychains that offer a modern, professional appearance-great for strong brand presence.",
    key:"keychain3",
    image: Keycahin3
  },
  {
    id: 4,
    name: "PVC Keychain",
    description: "Flexible and colorful PVC keychains—perfect for fun, bold, and creative brand expressions.",
    key: "keychain4",
    image: Keycahin4
  },
];

export default KeychainServiceCards;
